import { get } from 'lodash';
import { environments } from '../../config';

export const getApiBaseUrl = (state) => state.envConfig.apiBaseUrl;
export const getBankOrBrandId = (state) => get(state, 'envConfig.brandId', get(state, 'envConfig.bankId'));
export const getPAASApiBaseUrl = (state) => state.envConfig.apiBaseUrlPAAS;

const parseEnvFromTags = (envTags = []) => {
	if (envTags.indexOf(environments.local) !== -1) return environments.local;
	if (envTags.indexOf(environments.dev) !== -1) return environments.dev;
	if (envTags.indexOf(environments.int3) !== -1) return environments.int3;
	if (envTags.indexOf(environments.sit6) !== -1) return environments.sit6;
	if (envTags.indexOf(environments.production) !== -1) return environments.production;
	return environments.unknown;
};

export const getEnvName = (state) => parseEnvFromTags(state.envConfig.envTags);

export const isLocalEnv = (state) => parseEnvFromTags(state.envConfig.envTags) === environments.local;
